export default __webpack_public_path__ + "static/media/active-clock-icon-ionic.bcd454d45918fad49a712a9f7ac16936.svg";